import { type ChatWorkStep, ChatWorkStepState } from "../UIToolkit/Chat/chatWorkStepTypes";

const TRAILING_ELLIPSIS = /(?:…|\.\.\.)\s*$/u;

/** Fewer steps than this read fine as today's single status line; the list only earns its space from here. */
export const MIN_LISTED_WORK_STEPS = 2;

/** Appends a status line to the turn's trail; blank lines and any line already in the trail are dropped. */
export const appendWorkStep = (steps: readonly string[], text: string): string[] => {
	const step = text.trim();
	if (step === "" || steps.includes(step)) return [...steps];
	return [...steps, step];
};

/** A finished step reads as done ("Checking the schedule…" → "Checking the schedule"). */
export const doneLabel = (text: string): string => text.replace(TRAILING_ELLIPSIS, "").trimEnd();

/** The turn's trail as `ChatWorkSteps` rows: the step equal to `activeStep` is active and keeps its wording; the rest are done. */
export const chatWorkSteps = (steps: readonly string[], activeStep: string | null): ChatWorkStep[] =>
	steps.map((step, index) => {
		const isActive = step === activeStep;
		return {
			// Steps are append-only within a turn, so the index is a stable identity (text alone can repeat).
			id: `${index}-${step}`,
			label: isActive ? step : doneLabel(step),
			state: isActive ? ChatWorkStepState.Active : ChatWorkStepState.Done,
		};
	});
